<template>
    <div>
        <div class="container-fluid">
            <!-- Head -->
            <div class="d-flex align-items-center justify-content-between pt-4 mb-4">
                <div class="d-block">
                    <div class="h1-lg display-tektur m-0">Daftar Siswa</div>
                </div>
                <div class="d-block">
                    <button type="button" v-on:click="$parent.$parent.users_form('student');" class="btn btn-primary btn-lg btn-s-1">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-circle-plus fa-lg me-3"></i>Tambah Data</div>
                    </button>

                    <button type="button" v-on:click="goToPage('student')" class="btn btn-primary btn-lg btn-s-1" style="margin-left: 10px;">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-file-import fa-lg me-3"></i>Import Data</div>
                    </button>
                </div>
            </div>
        </div>

        <!-- Data -->
        <div class="card rounded-0 m-0 bg-card-trans-3">
            <div class="card-header">
                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                    <input class="form-control list-search" type="search" placeholder="Cari data disini..." v-model="keywords" v-on:keyup.enter="getData">
                        <span class="input-group-text">
                        <i class="fa-solid fa-search"></i>
                    </span>
                </div>

                <div class="d-flex align-items-center">
                    <div class="d-block me-3 text-muted">Filter:</div>
                    <div class="d-block" style="width:250px;">
                        <div class="form-select-wrapper">
                            <v-select
                                :options="dataYear"
                                label="name"
                                v-model="filter.graduation_year"
                                placeholder="Semua Tahun Lulus"
                                append-to-body
                                @input="set_graduation_year"
                                >
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="dataFetch" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Loading...</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!dataFetch && dataList.length > 0" class="card rounded-0 m-0 bg-card-trans-3">
            <div data-simplebar class="table-responsive" style="overflow-y:auto; height:72.9vh;">
                <table class="table table-sm table-hover card-table th-sticky">
                    <thead>
                        <tr>
                            <th class="text-center">No</th>
                            <th>Nama</th>
                            <th>Kelas</th>
                            <th>Tahun Lulus</th>
                            <th>Konsultan</th>
                            <th>Pilihan 1</th>
                            <th>Pilihan 2</th>
                            <th>Status Penerimaan</th>
                            <th>Aktif</th>
                            <th>Kata sandi</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="list fs-base">
                        <tr v-for="(item, index) in dataList" :key="index">
                            <td class="text-center">
                                {{ (index + 1) + (pagination.current_page - 1) * pagination.limit }}
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <div class="d-block me-3">
                                        <div class="avatar avatar-xs">
                                            <span class="avatar-title rounded-circle bg-white text-dark"><i class="fa-solid fa-user fa-lg m-0"></i></span>
                                        </div>
                                    </div>
                                    <div class="d-block">
                                        <div class="d-block data-nama-guru-mitra font-bold">{{ item.fullname }}</div>
                                        <span v-if="item.account_type == 'premium'" class="badge bg-success"><i class="fa-solid fa-star me-2"></i>Berbayar</span>
                                    </div>
                                </div>
                            </td>
                            <td class="text-center">{{ item.class ? item.class : '-' }}</td>
                            <td class="text-center">{{ item.graduation_year ? item.graduation_year : '-' }}</td>
                            <td>{{ item.rationalization.consultant_name ? item.rationalization.consultant_name : '-' }}</td>
                            <td>
                                <div class="d-block font-bold text-pink">{{ item.rationalization.university_one }}</div>
                                <div class="d-block text-sm">{{ item.rationalization.major_one }}</div>
                            </td>
                            <td>
                                <div class="d-block font-bold text-pink">{{ item.rationalization.university_two }}</div>
                                <div class="d-block text-sm">{{ item.rationalization.major_two }}</div>
                            </td>
                            <td>
                                <div class="d-block" v-if="item.rationalization.graduation_status == 0">
                                    <span class="badge bg-warning text-dark"><i class="fa-solid fa-info-circle me-2"></i>Belum Diterima</span>
                                </div>

                                <div class="d-block mb-1" v-if="item.rationalization.graduation_status == 1">
                                    <div class="d-block font-bold text-pink">
                                        {{ item.rationalization.pass_at_university }}
                                    </div>
                                    <div class="row">
                                        <div class="col-6">
                                            <div class="d-block small text-muted">Jurusan</div>
                                            <div class="d-block text-sm">{{ item.rationalization.pass_at_major }}</div>
                                        </div>
                                        <div class="col-6">
                                            <div class="d-block small text-muted">Tahun</div>
                                            <div class="d-block text-sm">{{ item.rationalization.graduation_year }}</div>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-block" v-if="item.rationalization.graduation_status == 1">
                                    <span class="badge bg-success text-dark"><i class="fa-solid fa-check-circle me-2"></i>Diterima jalur SNBP</span>
                                </div>                                
                            </td>
                            <td class="text-center">
                                <div class="d-block" v-if="item.active == 1">
                                    <span class="badge bg-success text-dark"><i class=""></i>Aktif</span>
                                </div>                                
                                <div class="d-block" v-if="item.active == 0">
                                    <span class="badge bg-danger text-dark"><i class=""></i>Tidak Aktif</span>
                                </div>                                
                            </td>
                            <td>
                                <button v-on:click="$parent.$parent.users_password_form(item.id);" type="button" class="btn btn-white btn-sm"><i class="fa-solid fa-lock me-2"></i>Ubah Kata Sandi</button>
                            </td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <button v-on:click="$parent.$parent.users_form('student', item.id);" type="button" class="btn btn-white-naked btn-sm me-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button v-on:click="deleteData(item.id)" type="button" class="btn btn-white-naked btn-sm text-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete">
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div aria-label="navigation" class="card-footer d-flex justify-content-between">

                <!-- Pagination (prev) -->
                <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                            <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                        </a>
                    </li>
                </ul>

                <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData()"></v-pagination>

                <!-- Pagination (next) -->
                <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                            Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                        </a>
                    </li>
                </ul>

            </div>            
        </div>

        <!-- Empty -->
        <div v-if="!dataFetch && emptyState" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
export default {
    name: 'StudentMain',
    metaInfo: {
        title: 'Daftar Siswa',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            keywords    : "",
            dataYear    : [],
            filter      : {
                graduation_year : null
            },
            graduation_year : "",
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 10,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'                
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            }
        }
    },
    created() {
        this.getYear();
        this.getData();
    },
    methods: {
        getYear: function() {
            let uri         = process.env.VUE_APP_APIHOST+'year/list';
            this.$http.get(uri).then(res => {
                // "empty" = siswa yang tahun lulusnya belum diisi.
                this.dataYear = res.data.data.concat([{ id: 'empty', name: 'Belum diisi' }]);
            });
        },
        set_graduation_year: function() {
            this.graduation_year            = this.filter.graduation_year ? this.filter.graduation_year.id : "";
            this.pagination.current_page    = 1;
            this.getData();
        },
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'users/list';

            this.dataFetch  = true;                
            this.$http.get(uri,{
                params : {
                    keywords : this.keywords,
                    page     : this.pagination.current_page,
                    limit    : this.pagination.limit,
                    role     : 'student',
                    graduation_year : this.graduation_year
                }
            }).then(res => {
                this.emptyState                 = false;
                this.dataFetch                  = false;                
                this.dataList                   = res.data.data;
                this.pagination.total_pages     = res.data.total_page;

                if(this.dataList.length < 1) {
                    this.emptyState = true;
                }
            });
        },
        pagination_handle: function(params) {
            if(params == 'next') {
                if(this.pagination.current_page < this.pagination.total_pages) {
                    this.pagination.current_page = this.pagination.current_page+1;
                    this.getData();
                }
            }

            if(params == 'prev') {
                if(this.pagination.current_page > 1) {
                    this.pagination.current_page = this.pagination.current_page-1;
                    this.getData();
                }
            }
        },
        goToPage: function(type) {
            this.$router.push({ name: 'import_users', params: { type: type } });
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'users/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.getData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        }
    }
}
</script>
